import React from "react";
import { message } from "antd";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../hooks/redux";
import "./HelpContactSection.scss";

const HelpContactSection = () => {
  const userId = useAppSelector((state) => state.user.user?.id);

  return (
    <section className="help-contact">
      <div>
        <h2>Need help with an order?</h2>
        <p>
          Keep your order email, selected product, material, and size ready so
          support can identify the purchase quickly.
        </p>
      </div>
      <div className="help-contact__actions">
        <Link
          to="/UserPage/order-history"
          className="help-button"
          onClick={(event) => {
            if (!userId) {
              event.preventDefault();
              message.warning('Please sign in to view your order history.');
            }
          }}
        >
          Order history
        </Link>
        <a href="mailto:support@truekarat.com" className="help-button">Email support</a>
      </div>
    </section>
  );
};

export default HelpContactSection;
